import { SprinklesElement } from "sprinkles-js";
import Sortable from "sortablejs";

export default class NestedFieldsElement extends SprinklesElement {
  static tagName = "nested-fields";
  static refs = ["template", "target"];
  static events = { click: "handleClick" };

  afterConnected() {
    this.sortableEnabled = this.dataset.sortable === "true";

    if (this.sortableEnabled && this.refs.target) {
      const handle =
        this.dataset.sortableHandle || "[data-nested-fields-handle]";

      this.sortable = new Sortable(this.refs.target, {
        animation: 150,
        handle,
        onUpdate: () => this.updateSortOrder(),
      });

      this.updateSortOrder();
    }
  }

  beforeDisconnected() {
    this.sortable?.destroy();
  }

  handleClick(event) {
    const addTrigger = event.target.closest(
      "[data-nested-fields-trigger='add']",
    );
    if (addTrigger) {
      event.preventDefault();
      this.addField();
      return;
    }

    const removeTrigger = event.target.closest(
      "[data-nested-fields-trigger='remove']",
    );
    if (removeTrigger) {
      event.preventDefault();
      this.removeField(removeTrigger.closest("[data-nested-form-wrapper]"));
    }
  }

  addField() {
    if (!this.refs.template || !this.refs.target) return;

    const newId = Date.now().toString();
    const content = this.refs.template.innerHTML.replace(/NEW_RECORD/g, newId);

    this.refs.target.insertAdjacentHTML("beforeend", content);
    this.updateSortOrder();
  }

  removeField(wrapper) {
    if (!wrapper) return;

    const destroyInput = wrapper.querySelector("input[name*='_destroy']");

    if (wrapper.dataset.newRecord === "true" || !destroyInput) {
      wrapper.remove();
    } else {
      destroyInput.value = "1";
      wrapper.hidden = true;
      wrapper.dataset.nestedFieldsRemoved = "true";
    }

    this.updateSortOrder();
  }

  updateSortOrder() {
    if (!this.sortableEnabled) return;

    const inputs = this.refs.target.querySelectorAll(
      "[data-nested-fields-sort-input]",
    );

    let index = 1;
    inputs.forEach((input) => {
      const wrapper = input.closest("[data-nested-form-wrapper]");
      if (wrapper?.dataset.nestedFieldsRemoved === "true") return;

      input.value = index;
      index += 1;
    });
  }
}
